import { render } from "./PricingPlanModal.vue?vue&type=template&id=af3e0108"
import script from "./PricingPlanModal.vue?vue&type=script&lang=js"
export * from "./PricingPlanModal.vue?vue&type=script&lang=js"

import "./PricingPlanModal.vue?vue&type=style&index=0&id=af3e0108&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__